import { appPath } from '../../routes/paths';
import { COMMISSIONS_CALCULATE_LABEL, COMMISSIONS_PAID_LABEL } from '../commissions/copy';
import { SETUP_CHILD_ROUTES, setupPath, type SetupChildPath } from '../settings/setupRoutes';
import { ACTIVITIES_NAV_ITEM } from '../tasks/copy';

export interface NavItemConfig {
  key: string;
  label: string;
  permission?: string;
}

export interface NavGroupConfig {
  label: string;
  children: NavItemConfig[];
}

function setupNavItem(path: SetupChildPath): NavItemConfig {
  const route = SETUP_CHILD_ROUTES.find((entry) => entry.path === path);
  if (route === undefined) {
    throw new Error(`Unknown setup route: ${path}`);
  }

  return {
    key: setupPath(route.path),
    label: route.label,
    permission: route.permission,
  };
}

export const NAV_GROUPS: NavGroupConfig[] = [
  {
    label: 'Dashboards',
    children: [
      { key: appPath(), label: 'Business Overview', permission: 'business-overview.view' },
      { key: appPath('/task-dashboard'), label: 'Task Dashboard', permission: 'tasks.dashboard.view' },
    ],
  },
  {
    label: 'Contacts',
    children: [
      { key: appPath('/contacts'), label: 'Contacts', permission: 'contacts.view' },
      setupNavItem('contact-categories'),
      setupNavItem('customer-segments'),
    ],
  },
  {
    label: 'Leads',
    children: [
      { key: appPath('/leads'), label: 'Leads', permission: 'leads.view' },
      { key: appPath('/leads/pipeline'), label: 'Pipeline', permission: 'leads.view' },
      setupNavItem('lead-pipeline-stages'),
    ],
  },
  {
    label: 'Operations',
    children: [
      { key: appPath('/documents'), label: 'Documents', permission: 'quotes.view' },
      { key: appPath('/tasks'), label: ACTIVITIES_NAV_ITEM, permission: 'tasks.view' },
    ],
  },
  {
    label: 'Offerings',
    children: [
      { key: appPath('/offerings'), label: 'Offerings', permission: 'offerings.view' },
      {
        key: appPath('/offerings/categories'),
        label: 'Categories',
        permission: 'offering-categories.view',
      },
    ],
  },
  {
    label: 'Marketing',
    children: [{ key: appPath('/campaigns'), label: 'Campaigns', permission: 'campaigns.view' }],
  },
  {
    label: 'Commissions',
    children: [
      {
        key: appPath('/commissions/calculator'),
        label: COMMISSIONS_CALCULATE_LABEL,
        permission: 'commissions.view',
      },
      {
        key: appPath('/commissions/reports'),
        label: COMMISSIONS_PAID_LABEL,
        permission: 'commissions.view',
      },
    ],
  },
  {
    label: 'Administration',
    children: [
      { key: appPath('/admin/users'), label: 'Users', permission: 'users.view' },
      { key: appPath('/admin/roles'), label: 'Roles', permission: 'roles.view' },
      { key: appPath('/bulk-operations'), label: 'Bulk Operations', permission: 'bulk-operations.view' },
    ],
  },
  {
    label: 'Host',
    children: [{ key: appPath('/host'), label: 'Tenant console', permission: 'host.tenants.view' }],
  },
];
